function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function Map(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.98 1c4.128 0 7.487 3.358 7.487 7.487 0 1.911-1.156 4.125-2.574 6.025l1.696-.002c.872 0 1.68.507 2.056 1.292l.043.104 1.012 2.897a2.797 2.797 0 01-.18 2.656 2.796 2.796 0 01-2.378 1.312H4.81a2.796 2.796 0 01-2.377-1.312c-.5-.795-.57-1.77-.194-2.626l.871-3.018a2.291 2.291 0 012.054-1.293l1.909-.001c-1.42-1.902-2.58-4.12-2.58-6.034C4.492 4.358 7.85 1 11.978 1zm6.61 15.51l-3.382.003c-1.393 1.473-2.715 2.463-3.229 2.463-.512 0-1.832-.987-3.223-2.457l-3.59.003a.285.285 0 00-.225.112l-.86 2.979a.802.802 0 00.045.78.801.801 0 00.684.378h14.332a.801.801 0 00.684-.378.802.802 0 00.045-.78l-.043-.103-1.003-2.873a.282.282 0 00-.235-.127zM11.98 3a5.494 5.494 0 00-5.488 5.487c0 3.131 4.067 7.128 5.48 8.281 1.433-1.172 5.495-5.159 5.495-8.28A5.494 5.494 0 0011.98 3zm0 2.078a3.514 3.514 0 013.51 3.51 3.516 3.516 0 01-3.51 3.51 3.515 3.515 0 01-3.51-3.51 3.513 3.513 0 013.51-3.51zm0 2c-.833 0-1.51.678-1.51 1.51 0 .833.677 1.51 1.51 1.51.832 0 1.51-.677 1.51-1.51 0-.832-.678-1.51-1.51-1.51z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
const MemoMap = /*#__PURE__*/React.memo(Map);
export default MemoMap;